import { Box, Button, Chip, Grid2, MenuItem, Modal, Select, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
// import { MenuItem } from "react-pro-sidebar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import editIcon from '../../assets/icons/edit.svg';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius:'8px'
};
const label = { inputProps: { 'aria-label': 'Switch demo' } };

const HomeScreenSettings = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [chips, setChips] = useState([]); // State to manage chips
    const [inputValue, setInputValue] = useState(''); // State to manage input value
    const [error, setError] = useState('');

    const [systemData, setSystemData] = useState([]);
    const [operatorData, setOperatorData] = useState([]);
    const [editing, setEditing] = useState(false);
    const [open, setOpen] = useState(false);

    const [selectedCategory, setSelectedCategory] = useState(1);
    const [active, setActive] = useState(false);
    const [displayOrder, setDisplayOrder] = useState('');
    const [updateCategoryId, setUpdateCategoryId] = useState('');
    const [userType, setUserType] = useState(0);

    const [greetingId, setGreetingId] = useState('');
    const [greetingStr, setGreetingStr]= useState('');

    const [activeInactiveFilter, setActiveInactiveFilter] = useState('active');
    const [userTypeFilter, setUserTypeFilter] = useState('customer');
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);

    const handleActiveInactiveChange = (event) => {
        setActiveInactiveFilter(event.target.value);
    };
    const handleUserTypeChange = (event) => {
        setUserTypeFilter(event.target.value);
    };
    const filteredActiveInactiveData = operatorData.filter((row) => {
        const isActive = activeInactiveFilter === "active" ? row.is_active === 1 : (activeInactiveFilter === "inactive" ? row.is_active === 0 : true);
    
        const isUserType = (userTypeFilter === 'customer' ? row.user_type === 0 : row.user_type === 1);
        
        return isActive && isUserType;
    });

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
        console.log('e=',e);
    }

    const handleOpen = (row) => {
        if(row && row.id) {
            setUpdateCategoryId(row.id);
            setDisplayOrder(row.display_order);
            setActive(row.is_active==1)
            setUserType(row.user_type);
            setSelectedCategory(row.category_id)
            setEditing(true);
        }
        else{
            setUpdateCategoryId('');
            setDisplayOrder('');
            setActive(false)
            setSelectedCategory(1);
            setUserType(0);
            setEditing(false);
        }
        setOpen(true);
    }
    const handleClose = () => setOpen(false);
    

    const handleCategoryChange = (event) => {
        setSelectedCategory(event.target.value);
    };

    useEffect(() => {
        if(greetingStr != '' ) {
            saveGreetingsToAPI();
        }
    }, [greetingStr]); 

    const makeGreetingStr = (prevChips, newChip, str) => {
        let strGreetings="";
        if (str=='delete') {
            if(prevChips){
                strGreetings =  prevChips
                .split(',') // Split the string into an array of greetings
                .filter((greeting) => greeting !== newChip) // Filter out the greeting to delete
                .join(','); // Join the remaining greetings back into a string
            }
            
        }
        else strGreetings =  prevChips ? `${prevChips},${newChip}` : newChip;

        setGreetingStr(strGreetings);
    }

    const saveGreetingsToAPI = async() => {
        try {
            const token = localStorage.getItem('token');
            const clientId = localStorage.getItem('clientId');
            const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
            const body = {
                token: token,
                // client_id: clientId,
                city_id: cityFilter,
                user_type: userType,
                geofence_id: -2,
                is_active: 1, 
                addn_info: greetingStr,
                // category_id:-1
                // display_order: displayOrder
            };

            if(greetingId){
                body.obc_id = greetingId
            }

            const response = await fetch(operationsUrl + '/panel/create_and_update_home_screen_categories', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();

            if (response.ok) {
                handleClose();
                fetchCategory();
            } 
            else {
                setError(data.message || 'Login failed. Please try again.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    }

    // Handle adding a new chip
    const handleAddChip = () => {
        if (inputValue.trim() !== '') {
            const newChip = inputValue.trim();  // Directly use the trimmed string

            // Add the new chip to the list (as a single string)
            setChips((prevChips) => [
                ...prevChips,
                { greetings: newChip },  // Store each chip as a single greeting string
            ]);

            // If needed, update greetingId
            setGreetingId(chips[0]?.id);

            // Update the greeting string (the state used to track the greetings)
            makeGreetingStr(chips[0]?.greetings, newChip, 'add');

            // Clear the input field
            setInputValue('');
        }
    };

    // Handle deleting a chip
    const handleDeleteChip = (greetingToDelete) => {
        // setChips((prevChips) =>
        //     prevChips
        //         .map((chip) => ({
        //             ...chip,
        //             greetings: chip.greetings.split(',').filter((greeting) => greeting !== greetingToDelete).join(','),  // Remove the greeting from the string
        //         }))
        //         .filter((chip) => chip.greetings !== ''),  // Remove empty chips
        // );

        // setGreetingId(chips[0].id);
        // makeGreetingStr(chips[0].greetings, greetingToDelete, 'delete');
        setChips((prevChips) => {
            const updatedChips = prevChips
                .map((chip) => ({
                    ...chip,
                    greetings: chip.greetings
                        .split(',')
                        .filter((greeting) => greeting !== greetingToDelete) // Remove the greeting to delete
                        .join(','), // Re-join the remaining greetings
                }))
                .filter((chip) => chip.greetings !== ''); // Remove empty chips
    
            // Call makeGreetingStr with the updated greeting string after deleting

            setGreetingId(chips[0]?.id);
            makeGreetingStr(updatedChips[0]?.greetings, greetingToDelete, 'delete');
            return updatedChips;
        });
    };
    
    const viewData = (row) => {
        navigate('/homeScreen-details', { state: { rowData: row , godData: systemData} });
    };

    const saveCategory = async (val) => {
        try {
            const token = localStorage.getItem('token');
            const clientId = localStorage.getItem('clientId');
            const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
            const body = {
                token: token,
                client_id: clientId,
                city_id: cityFilter,
                user_type: userType,
                geofence_id: -2,
                user_type: userType,
                is_active: active===true ? 1 : 0, 
                display_order: displayOrder
            };

            if(editing && updateCategoryId !== 0){
                body.obc_id = updateCategoryId;
            }
            if(!editing){
                body.category_id= selectedCategory
            }

            const response = await fetch(operationsUrl + '/panel/create_and_update_home_screen_categories', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();

            if (response.ok) {
                handleClose();
                fetchCategory();
            } 
            else {
                setError(data.message || 'Login failed. Please try again.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    };

    const fetchCategory = async () => {
        try {
            const token = localStorage.getItem('token');
            const clientId = localStorage.getItem('clientId');
            const timestamp = new Date().getTime();
            const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
            const queryParams = new URLSearchParams({
                token: token,
                city_id: cityFilter,
                client_id: clientId,
                timestamp: timestamp
            }).toString();

            const url = `${serverUrl}/panel/get_home_screen_banner_categories?${queryParams}`;

            const response = await fetch(url);
            const data = await response.json();

            if (response.ok) {
                setSystemData(data.data.system_banners)

                setChips(data.data.greetings || []);

                setOperatorData(data.data.operator_banners);
            } 
            else {
                setError(data.message || 'Login failed. Please try again.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    };

    useEffect(() => {
        fetchCategory();
    }, [cityFilter]);

    return(
        <div>
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>HomeScreen Settings</Typography>

            <Grid2 item sx={{marginTop:'2%'}}>
                <Select value={cityFilter} onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                style={{width: '220px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                    <MenuItem value="">Select City</MenuItem>
                    {cities.map((city) => (
                        <MenuItem key={city.city_name} value={city.city_id}>
                            {city.city_name}
                        </MenuItem>
                    ))}
                </Select>
            </Grid2>

            <Grid2 className="mainBox" spacing={8} sx={{marginTop:'2%', padding:'2%'}}>
                <Grid2 container>
                    <Grid2 item sx={{marginTop:'1%'}}>
                        <Typography sx={{fontSize:'18px'}}>Greetings :</Typography>
                    </Grid2>
                    <Grid2 item sx={{marginLeft:'6%'}}>
                        <TextField size="small"
                            value={inputValue} 
                            onChange={(e) => setInputValue(e.target.value)} // Update input value
                            placeholder="Enter a greeting" 
                            sx={{ width: '300px', height:'40px' }}
                        />
                    </Grid2>
                    <Grid2 item sx={{marginLeft:'8%'}}>
                        <Button onClick={handleAddChip} variant="contained" sx={{width: '120px', height: '40px', marginRight: '12px', backgroundColor: '#0065FF', textTransform:'none', borderRadius:'8px'}}>
                            Add
                        </Button>
                    </Grid2>
                </Grid2>    

                <Grid2 sx={{marginTop:'2%'}}>
                    <Stack direction="row" spacing={1}>
                        {chips && Array.isArray(chips) && chips.length > 0 ? (
                            chips.map((chip, index) => {
                                const greetingsArray = chip.greetings.split(',');

                                return greetingsArray.map((greeting, subIndex) => (
                                    <Chip
                                        key={`${index}-${subIndex}`}  // Unique key for each chip, combining index and subIndex
                                        label={greeting}  // Display each greeting individually
                                        variant="outlined"
                                        onDelete={() => handleDeleteChip(greeting)}  // Delete chip on click
                                    />
                                ));
                            })
                        ) : (
                            <p>No greetings available</p>  // Fallback if chips is empty or undefined
                        )}
                    </Stack>
                </Grid2>
            </Grid2>

            <Grid2 className="mainBox" sx={{marginTop:'2%'}}>
                <Grid2>
                    <Grid2 sx={{display:'flex'}}>
                        <Grid2 item>
                            <Button onClick={handleOpen} variant="contained"
                                sx={{
                                    backgroundColor: 'black', color: 'white', border: '1px solid black',
                                    textTransform: 'none', borderRadius: '8px', width: 'auto', minWidth: '120px',
                                    '&:hover': { backgroundColor: 'white', color: 'black'}
                                }}>
                                    Add
                            </Button>
                        </Grid2>
                        
                        <Grid2 item sx={{marginLeft:'4%'}}>
                            
                            <Select
                                value={activeInactiveFilter}
                                onChange={handleActiveInactiveChange}
                                size="small"
                                sx={{ minWidth: "180px" }}
                            >
                                <MenuItem value="active">Active</MenuItem>
                                <MenuItem value="inactive">Inactive</MenuItem>
                            </Select>
                        </Grid2>

                        <Grid2 item sx={{ marginLeft: '4%' }}>
                            <Select
                                value={userTypeFilter}
                                onChange={handleUserTypeChange}
                                size="small"
                                sx={{ minWidth: "180px" }}
                            >
                                {/* <MenuItem value="all">All</MenuItem> */}
                                <MenuItem value="customer">Customer</MenuItem>
                                <MenuItem value="driver">Driver</MenuItem>
                            </Select>
                        </Grid2>

                    </Grid2>
                    

                    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={style}>
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Add Data
                            </Typography>
                            <hr/>
                            <Grid2 id="modal-modal-description" sx={{ mt: 2 }}>
                                <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                                    <Grid2 item size={4}>
                                        <Typography>Category</Typography>
                                    </Grid2>
                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                    <Grid2 item size={6}>
                                        {
                                            editing ? (
                                                <Grid2>
                                                    <Typography>
                                                        {selectedCategory==1 ? 'Promotions' : (selectedCategory==2 ? 'Refer & Earn' : selectedCategory==3 ? 'Verify Douments': selectedCategory==4 ? "What's New" : selectedCategory==5 ? 'Why Mobility' : 'Video' )}
                                                        
                                                    </Typography>
                                                </Grid2>
                                            ):(
                                                <select style={{width:'300px', height:'40px', marginLeft:'4%'}}
                                                value={selectedCategory} onChange={handleCategoryChange}
                                                >
                                                    {systemData && systemData.length > 0 ? (
                                                        systemData.map((item) => (
                                                            <option key={item.id} value={item.id}>
                                                                {item.name}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="">No categories available</option> // Fallback if systemData is empty
                                                    )}
                                                </select>
                                            )

                                        }
                                        
                                    </Grid2>
                                </Grid2>

                                <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                                    <Grid2 item size={4}>
                                        <Typography>Display order</Typography>
                                    </Grid2>
                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                    <Grid2 item size={6}>
                                        <TextField size="small"
                                            value={displayOrder}
                                            onChange={(e) => setDisplayOrder(e.target.value)}
                                            sx={{ width: '300px', height:'30px', marginLeft:'4%' }}
                                        />
                                    </Grid2>
                                </Grid2>

                                <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                                    <Grid2 item size={4}>
                                        <Typography>Geofence Name</Typography>
                                    </Grid2>
                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                    <Grid2 item size={6}>
                                        <Typography sx={{marginLeft:'4%'}}>Default</Typography>
                                        {/* <TextField size="small"
                                            onChange={(e) => setInputValue(e.target.value)}
                                            sx={{ width: '300px', height:'30px', marginLeft:'4%' }}
                                        /> */}
                                    </Grid2>
                                </Grid2>

                                <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{marginTop:'1%'}}>User Type</Typography>
                                    </Grid2>
                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%', marginTop:'6%'}}>:</Typography></Grid2>
                                    <Grid2 item size={6}>
                                        <select style={{width:'300px', height:'40px', marginLeft:'4%'}}
                                        value={userType} onChange={(e) => setUserType(e.target.value)}>
                                            <option value="0">Customer</option>
                                            <option value="1">Driver</option>
                                        </select>
                                        {/* <Switch checked={active} onChange={(e) => setActive(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} /> */}
                                    </Grid2>
                                </Grid2>

                                <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{marginTop:'1%'}}>Active</Typography>
                                    </Grid2>
                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%', marginTop:'6%'}}>:</Typography></Grid2>
                                    <Grid2 item size={6}>
                                        <Switch checked={active} onChange={(e) => setActive(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />
                                    </Grid2>
                                </Grid2>

                                <Grid2 container spacing={12} sx={{marginLeft:'20%', marginTop:'6%'}}>
                                    <Grid2 item ><Button variant="contained" sx={{width:'120px'}} onClick={saveCategory}>Save</Button></Grid2>
                                    <Grid2 item ><Button onClick={handleClose} variant="contained" color="error"  sx={{width:'120px'}}>Cancel</Button></Grid2>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </Modal>
                </Grid2>
                <TableContainer className="table-container">
                    <Table stickyHeader className="scrollable-table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" className="table-header">
                                    Category
                                </TableCell>
                                <TableCell align="center" className="table-header">
                                    Display Order
                                </TableCell>
                                <TableCell align="center" className="table-header">
                                    Active
                                </TableCell>
                                <TableCell align="center" className="table-header">
                                    User Type
                                </TableCell>
                                <TableCell align="center" className="table-header">
                                    Geofence Name
                                </TableCell>
                                <TableCell align="center" className="table-header">
                                    Action
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredActiveInactiveData && filteredActiveInactiveData.length > 0 ? (
                                filteredActiveInactiveData.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell align="center">
                                        {row.name}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.display_order}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.is_active == 1 ? 'Yes' : 'No'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.user_type == 0 ? 'Customer' : 'Driver'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.geofence_name}
                                    </TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained" onClick={() => handleOpen(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', padding:'4%', minWidth:'40px', boxShadow:'none',
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            {/* <img src={editIcon} alt="Edit" style={{padding:"0px"}}/> */}
                                            {/* <Typography sx={{marginRight:'8%'}}>Edit</Typography> */}
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>
                                        {/* <br/> */}
                                        <Button
                                            variant="contained"
                                            onClick={() => viewData(row)}
                                            sx={{
                                                backgroundColor: 'white', color: 'black', border: '1px solid black', textTransform: 'none',
                                                borderRadius: '8px', width: 'auto', minWidth: '100px', marginLeft:'2%', boxShadow:'none',
                                                '&:hover': {backgroundColor: 'black', color: 'white'},
                                                '&:active': { backgroundColor: 'black', color: 'white'}
                                            }}>
                                            Details
                                        </Button>
                                        
                                    </TableCell>
                                </TableRow>
                                ))
                            ): (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">No data available</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                
            </Grid2>

        </div>
    )
}

export default HomeScreenSettings; 